import { BrushType, HEXcolor, SelectedBrushType } from '@/shared/types'

export class BrushMapAddedBrushes {
  public selectedBrush: SelectedBrushType
  public firstGroupBrushes: BrushType[]
  public secondGroupBrushes: BrushType[]

  constructor() {
    this.clearBrushes()
  }

  public setBrushes(firstGroup: BrushType[], secondGroup: BrushType[]): void {
    this.firstGroupBrushes = firstGroup
    this.secondGroupBrushes = secondGroup
  }

  public clearBrushes(): void {
    this.selectedBrush = this.getDefaultSelectedBrush()
    this.firstGroupBrushes = []
    this.secondGroupBrushes = []
  }

  public deleteBrushOfFirstGroup(brush: BrushType): void {
    this.firstGroupBrushes = this.firstGroupBrushes.filter(
      (colorGroup) => colorGroup !== brush
    )
  }

  public deleteBrushOfSecondGroup(deletedBrush: BrushType): void {
    this.secondGroupBrushes = this.secondGroupBrushes.filter(
      (brush) => brush !== deletedBrush
    )
  }

  public addSelectedBrush(): void {
    const { type, colorName, color } = this.selectedBrush
    if (type === 1) {
      this.firstGroupBrushes.push({ color, colorName: colorName })
    } else {
      this.secondGroupBrushes.push({ color, colorName: colorName })
    }
  }

  public addBrush(brush: SelectedBrushType): void {
    const { type, colorName, color } = brush
    if (type === 1) {
      this.firstGroupBrushes.push({ color, colorName: colorName })
    } else {
      this.secondGroupBrushes.push({ color, colorName: colorName })
    }
  }

  public deleteBrush(color: HEXcolor): void {
    const firstGroupContainColor = this.isContainColor(
      this.firstGroupBrushes,
      color
    )
    const secondGroupContainColor = this.isContainColor(
      this.secondGroupBrushes,
      color
    )

    if (!(firstGroupContainColor || secondGroupContainColor)) {
      return
    }

    const groupFilter = (brush: BrushType) => brush.color !== color

    if (firstGroupContainColor) {
      this.firstGroupBrushes = this.firstGroupBrushes.filter(groupFilter)
      return
    }

    this.secondGroupBrushes = this.secondGroupBrushes.filter(groupFilter)
  }

  private getDefaultSelectedBrush(): SelectedBrushType {
    return {
      color: '#b3b3b3',
      colorName: 'Выберите цвет',
      type: 1,
    }
  }

  private isContainColor(
    brushes: BrushType[],
    checkedColor: HEXcolor
  ): boolean {
    const groupIsContainColor = brushes.find(
      (brush) => brush.color === checkedColor
    )

    return Boolean(groupIsContainColor)
  }
}
